import React, {useContext, useEffect, useRef, useState} from 'react';
import Header from '../components/Header';
import OleCheckbox from '../components/OleCheckbox';
import FormFlyware from '../components/FormFlyware';
import LinkOptionContext from '../contexts/LinkOptionContext';
import { languageMessages } from 'traductor/PaymentLink';
import { useLocation } from 'react-router-dom';
import { LinkResponse, TransformedData, transformLinkResponse, sumCheckedDues, resolveLinkOption, canOpenLink, hasPaymentWindow, linkUrlWithOption, resolveConfirmationAmount } from 'services/link/types';
import { getHashInfo, isPaymentPending } from 'services/link/linkService';
import Dialog from '../components/OleDialog';
import OlePopupInformation from '../components/OlePopupInformation';
import EarlyPaymentPopup from '../components/EarlyPaymentPopup';
import Skeleton from '../components/Skeleton';
import PageConfirmation from './PageConfirmation';
import { checkout } from 'services/checkout/checkoutService';
import { CheckoutRequest } from 'services/checkout/types';
import { CardUpdateRequest } from 'services/card/types';
import { updateCard } from 'services/card/CardService';
import LanguageContext from 'contexts/LanguageContext';
import FormPersonalData from 'components/FormPersonalData';
import '../styles/PaymentLink.css'
import Layout from 'Layout';
import { REACT_APP_COUNTRY_DEPLOY, REACT_APP_TIME_REFRESH } from 'config';
//import FormStripe from 'components/FormStripe';
//import { StripeWrapper } from 'components/StripeWrapper';
//import { Popup } from '@ole/react-library-agents';
import { getAmountWithTwoDecimalsAndMilles } from 'services/common';
import { useProvider } from 'hooks/useProvider';
import FormAuthorizeNet from '../components/FormAuthorizeNet';
import { useAuthorizeNetLinkHandler } from '../hooks/useAuthorizeNetLinkHandler';
import { AuthnetPayerBody } from 'services/authorizeNet/types';
import { PaymentOutcome, REJECTED, expectsBankTransfer, isCardPayment, resolvePaymentOutcome } from 'services/payment/outcome';
import * as Sentry from '@sentry/react';

interface PaymentLinkProps {
    language: string;
    region: string;
}

function PaymentLink({language, region}: PaymentLinkProps) {
    const { getProvider } = useProvider();
    const [token, setToken] = useState('');
    const location = useLocation();
    // eslint-disable-next-line
    const [selectedLinkOption, setSelectedLinkOption] = useState<string>(() => resolveLinkOption(location.search));
    const [sessionLoaded, setSessionLoaded] = useState(false);
    const [canPay, setCanPay] = useState(true);
    const [sessionData, setSessionData] = useState<LinkResponse | null>(null);
    const [objectData, setObjectData] = useState<any>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenInformation, setIsOpenInformation] = useState(false);
    const [isOpenEarlyPayment, setIsOpenEarlyPayment] = useState(false);
    
    const [success, setSuccess] = useState(false);
    const [status, setStatus] = useState<string>();
    const [paymentMethod, setPaymentMethod] = useState<string>();
    const [result, setResult] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [retry, setRetry] = useState(-1);
    const [stepActive, setStepActive] = useState(true);
    const [informationPayment, setInformationPayment] = useState<Map<string, string>>(new Map());
    const [informationUpdate, setInformationUpdate] = useState<Map<string, string>>(new Map());
    // eslint-disable-next-line
    const { changeLanguage } = useContext(LanguageContext);
    const RECURRENT_ALWAYS = true
    // eslint-disable-next-line
    const [INSURED_TEXT, setInsuredText] = useState(languageMessages(language, 'insured'))
    // eslint-disable-next-line
    const [POLICY_OWNER_TEXT, setPolicyOwnerText] = useState(languageMessages(language, 'policyOwner'))
    // eslint-disable-next-line
    const [POLICY_NUMBER_TEXT, setPolicyNumberText] = useState(languageMessages(language, 'policyNumber'))
    // eslint-disable-next-line
    const [PLAN, setPlan] = useState(languageMessages(language, 'plan'))
    // eslint-disable-next-line
    const [TERM, setTerm] = useState(languageMessages(language, 'term'))
    // eslint-disable-next-line
    const [PREMIUM, setPremium] = useState(languageMessages(language, 'premium'))
    const [isVantage, setIsVantage] = useState(false);
    //const [openPopupStripe, setOpenPopupStripe] = useState(false);
    const [amountPayment, setAmountPayment] = useState(0);
    const checkingPendingRef = useRef(false);

    const buildLinkPayer = (data: any): AuthnetPayerBody => ({
        first_name: data.payerFirstName,
        last_name: data.payerLastName,
        middle_name: data.payerMiddleName,
        address1: data.address,
        address2: '',
        city: data.city || data.cityForFlywire,
        state: data.state,
        zip: data.zipCode,
        country: data.country,
        phone: data.phone,
        email: data.email,
        paymaster: data.payingForPolicy,
        paymaster_relationship: data.relationship,
    });

    const {
        formToken: authnetFormToken,
        isLoaded: authnetLoaded,
        startAuthorizeNetLink,
        closeAuthorizeNetLink,
    } = useAuthorizeNetLinkHandler({
        hash: token,
        region,
        applicationId: objectData?.idApplication || '',
        onError: () => setIsOpen(true),
        onSuccess: () => {
            setRetry(-1);
            setSuccess(true);
            if (selectedLinkOption === 'payment') {
                setStatus('success');
                setAmountPayment(objectData?.amount ?? 0);
            } else {
                setStatus('success');
            }
        },
    });

    const logFlywireOutcome = (dato:any, gateway:string, outcome:PaymentOutcome) => {
        const payload = {
            session: token,
            gateway,
            status: dato?.args?.status,
            outcome,
            paymentMethod: dato?.args?.paymentMethod,
            reference: dato?.args?.reference,
        };
        if (outcome === REJECTED) {
            Sentry.logger.error('PaymentLink[payment rejected]', payload);
            return;
        }
        Sentry.logger.info('PaymentLink[checkout completed]', payload);
    }

    const responseflywire = async(dato:any) => {
        if (dato.success) {
            const gateway = getProvider(region, objectData?.gateway);
            const outcome = resolvePaymentOutcome(gateway, dato?.args?.status);
            logFlywireOutcome(dato, gateway, outcome);
            setRetry(-1);
            setSuccess(true);
            setResult(dato?.args);
            setStatus(dato?.args.status)
            setPaymentMethod(dato?.args?.paymentMethod)
            if (outcome === REJECTED) return;
            try {
                const ids = objectData.dues.filter((due: any) => due.checked).map((due: any) => { return due.id; });
                if (parseFloat(dato?.args.amount) > 0) {
                    if (isCardPayment(dato?.args.paymentMethod)) {
                        let recurrentOption = objectData.recurrent;
                        if (dato?.args.token !== '') {
                            recurrentOption = true;
                        }
                        const checkoutData:CheckoutRequest = {
                        application_id: objectData.idApplication,
                        card: {
                            "brand": dato?.args.brand,
                            "digits": dato?.args.digits,
                            "expirationMonth": dato?.args.expirationMonth,
                            "expirationYear": dato?.args.expirationYear,
                            "sig": dato?.args.sig,
                            "token": dato?.args.token,
                            "type": dato?.args.type,
                            "recurrent": recurrentOption,
                        },
                        "ids": ids,
                        "reference": dato?.args.reference,
                        "amount_from": dato?.args.payerAmount,
                        "amount_to": parseFloat(dato?.args.amount),
                        "currency_from": dato?.args.payerAmountCurrency,
                        "currency_to": dato?.args.amountCurrency,
                        "paymentMethod": dato?.args.paymentMethod,            
                        "status": dato?.args.status,
                        payer: {
                            first_name: objectData.payerFirstName,
                            last_name: objectData.payerLastName,
                            middle_name: objectData.payerMiddleName,
                            address1: objectData.address,
                            address2: '',
                            city: objectData.city || objectData.cityForFlywire,
                            state: objectData.state,
                            zip: objectData.zipCode,
                            country: objectData.country,
                            phone: objectData.phone,
                            email: objectData.email,
                            paymaster: objectData.payingForPolicy,
                            paymaster_relationship: objectData.relationship,
                        },
                        };
                        console.log(`checkout(${objectData.country})`, checkoutData);
                        const res = await checkout(checkoutData, objectData.country, region, 'FLY', token);
                        if (res.success) {
                            console.log('checkout (response)', 'success');
                            setAmountPayment(parseFloat(dato?.args.amount));
                        } else {
                            console.error('checkout (response)', res.error);
                        }
                    } else {
                        console.warn('checkout', 'paymentMethod not supported');
                    }
                } else {
                    const cardData:CardUpdateRequest = {
                      brand: dato?.args.brand,
                      digits: dato?.args.digits,
                      expirationMonth: dato?.args.expirationMonth,
                      expirationYear: dato?.args.expirationYear,
                      sig: dato?.args.sig,
                      token: dato?.args.token,
                      type: dato?.args.type,
                      recurrent: RECURRENT_ALWAYS,
                      payer: {
                        first_name: objectData.payerFirstName,
                        last_name: objectData.payerLastName,
                        middle_name: objectData.payerMiddleName,
                        address1: objectData.address,
                        address2: '',
                        city: objectData.city || objectData.cityForFlywire,
                        state: objectData.state,
                        zip: objectData.zipCode,
                        country: objectData.country,
                        phone: objectData.phone,
                        email: objectData.email,
                        paymaster: objectData.payingForPolicy,
                        paymaster_relationship: objectData.relationship,
                      }
                    };
                    console.log(`updateCard(${objectData.country})`, cardData);
                    const res = await updateCard(cardData, objectData.country, token, region);
                    if (res.success) {
                        console.log('updateCard(response)', res);
                    } else {
                        console.error('updateCard(response)', res.error);
                    }
                }
            } catch (error) {
                setIsOpen(true);
                console.error('flywire callback', error);
            }
        }
    }

    /*const responseStripe = async(dato:any, customProvider:string) => {
        if (dato.status === 'succeeded') {
            console.log('flywire callback', dato);
            setRetry(-1);
            setSuccess(true);
            setResult(dato);
            setStatus(dato.status)
            try {
                const ids = objectData.dues.filter((due: any) => due.checked).map((due: any) => { return due.id; });
                if (selectedLinkOption === 'payment' && parseFloat(dato?.amount) > 0) {
                    let recurrentOption = objectData.recurrent;
                    recurrentOption = true;
                    const checkoutData:CheckoutRequest = {
                    application_id: objectData.idApplication,
                    card: {
                        "token": dato?.payment_method,
                        "recurrent": recurrentOption,
                        "customer_provider_id": customProvider,
                    },
                    "ids": ids,
                    "reference": dato?.id,
                    "amount_from": dato?.amount,
                    "amount_to": dato?.amount,
                    "currency_from": dato?.currency,
                    "currency_to": dato?.currency,
                    "paymentMethod": dato?.payment_method_types[0] || 'card',
                    "status": dato?.status === 'succeeded' ? 'success' : 'pending',
                    payer: {
                        first_name: objectData.payerFirstName,
                        last_name: objectData.payerLastName,
                        middle_name: objectData.payerMiddleName,
                        address1: objectData.address,
                        address2: '',
                        city: objectData.city || objectData.cityForFlywire,
                        state: objectData.state,
                        zip: objectData.zipCode,
                        country: objectData.country,
                        phone: objectData.phone,
                        email: objectData.email,
                        paymaster: objectData.payingForPolicy,
                        paymaster_relationship: objectData.relationship,
                    },
                    };
                    console.log(`checkout(${objectData.country})`, checkoutData);
                    const res = await checkout(checkoutData, objectData.country, region, 'STP', token);
                    if (res.success) {
                        console.log('checkout (response)', 'success');
                        setAmountPayment(parseFloat(dato?.amount));
                    } else {
                        console.error('checkout (response)', res.error);
                    }
                } else {
                    const cardData:CardUpdateRequest = {
                      token: dato?.payment_method,
                      recurrent: RECURRENT_ALWAYS,
                      customer_provider_id: customProvider,
                      payer: {
                        first_name: objectData.payerFirstName,
                        last_name: objectData.payerLastName,
                        middle_name: objectData.payerMiddleName,
                        address1: objectData.address,
                        address2: '',
                        city: objectData.city || objectData.cityForFlywire,
                        state: objectData.state,
                        zip: objectData.zipCode,
                        country: objectData.country,
                        phone: objectData.phone,
                        email: objectData.email,
                        paymaster: objectData.payingForPolicy,
                        paymaster_relationship: objectData.relationship,
                      }
                    };
                    console.log(`updateCard(${objectData.country})`, cardData);
                    const res = await updateCard(cardData, objectData.country, token, region, 'STP');
                    if (res.success) {
                        console.log('updateCard(response)', res);
                    } else {
                        console.error('updateCard(response)', res.error);
                    }
                }
            } catch (error) {
                setIsOpen(true);
                console.error('flywire callback', error);
            } finally {
                setOpenPopupStripe(false);
            }
        }
    }*/

    useEffect(() => {
        const newData: Partial<TransformedData> = { language: language };
        setObjectData((prevData: any) => ({ ...prevData, ...newData }));
        const A1 = languageMessages(language, 'insured')
        //const A2 = languageMessages(language, 'policyOwner')
        const A3 = languageMessages(language, 'policyNumber')
        const A5 = languageMessages(language, 'term')
        const A6 = languageMessages(language, 'premium')
        setInsuredText(languageMessages(language, 'insured'))
        setPolicyOwnerText(languageMessages(language, 'policyOwner'))
        setPolicyNumberText(languageMessages(language, 'policyNumber'))
        setPlan(languageMessages(language, 'plan'))
        setTerm(languageMessages(language, 'term'))
        setPremium(languageMessages(language, 'premium'))
        setInformationPayment(new Map(Object.entries(
            {
                [A1]: sessionData?.first_name + ' ' + sessionData?.last_name,
                //[A2]: sessionData?.first_name + ' ' + sessionData?.last_name,
                [A3]: sessionData?.id_application || '',
            }
        )));
        const nextPayment = sessionData?.payments?.[0];
        setInformationUpdate(new Map(Object.entries(
            {
                [A1]: sessionData?.first_name + ' ' + sessionData?.last_name || '',
                [A3]: sessionData?.id_application || '',
                [A5]: sessionData?.term || '',
                ...(nextPayment && { [A6]: sessionData?.currency + ' $' + nextPayment.amount }),
            }
        )));
        // eslint-disable-next-line
    }, [language, sessionData]);

    useEffect(() => {
        document.documentElement.style.setProperty('--fwpDisplayForm', 'none');
        document.documentElement.style.setProperty('--fwpDisplayData', 'block');

        const queryParams = new URLSearchParams(location.search);
        const sessionToken = queryParams.get('subscription') ?? '';
        const originVantage = queryParams.get('origin') ?? '';
        setToken(sessionToken);
        setIsVantage(originVantage === 'app-mobile');
        localStorage.setItem('selectedLinkOption', resolveLinkOption(location.search));
    
        if (!sessionToken) {
            console.error('session', languageMessages(language, 'errorMessages')['payment'].subtitle);
            setError({
                title: languageMessages(language, 'errorMessages')['payment'].title,
                subtitle: languageMessages(language, 'errorMessages')['payment'].subtitle,
                buttonText: languageMessages(language, 'errorMessages')['payment'].buttonText
            });
            setIsOpen(true);
            return;
        }

        if (sessionLoaded) return;

        let isMounted = true;
        const fetchData = async () => {
            try {
                console.log('calling getHashInfo with region:', region);
                const session:any = await getHashInfo(sessionToken, region);
                if (!isMounted) return;
                if (session?.error === true) {
                    setError({
                        title: languageMessages(language, 'errorMessages')['session'].title,
                        subtitle: languageMessages(language, 'errorMessages')['session'].subtitle,
                        buttonText: languageMessages(language, 'errorMessages')['session'].buttonText
                    });
                    setIsOpen(true);
                    console.warn('session', languageMessages(language, 'errorMessages')['session'].subtitle);
                    return;
                }

                const hasPayableInstallment = (session.payments?.length ?? 0) > 0;
                setCanPay(hasPayableInstallment);
                const opensInPaymentMode = resolveLinkOption(location.search) === 'payment';
                if (!hasPayableInstallment && opensInPaymentMode && hasPaymentWindow(REACT_APP_COUNTRY_DEPLOY)) {
                    localStorage.setItem('selectedLinkOption', 'update');
                    setSelectedLinkOption('update');
                } else if (!canOpenLink(resolveLinkOption(location.search), session.payments)) {
                    setError({
                        title: languageMessages(language, 'errorMessages')['notPendingPayments'].title,
                        subtitle: languageMessages(language, 'errorMessages')['notPendingPayments'].subtitle,
                        buttonText: languageMessages(language, 'errorMessages')['notPendingPayments'].buttonText
                    });
                    setIsOpen(true);
                    console.warn('session', languageMessages(language, 'errorMessages')['notPendingPayments'].subtitle);
                    return;
                }
                setSessionData(session);
                setObjectData(transformLinkResponse(session));
                const languageMap: { [key: string]: string } = {
                    EN: 'en',
                    US: 'en',
                    SP: 'es',
                    PT: 'pt',
                    ES: 'es',
                };
                changeLanguage(languageMap[session.language]);
                const A1 = languageMessages(languageMap[session.language], 'insured')
                //const A2 = languageMessages(languageMap[session.language], 'policyOwner')
                const A3 = languageMessages(languageMap[session.language], 'policyNumber')
                const A5 = languageMessages(languageMap[session.language], 'term')
                const A6 = languageMessages(languageMap[session.language], 'premium')
                setInsuredText(languageMessages(languageMap[session.language], 'insured'))
                setPolicyOwnerText(languageMessages(languageMap[session.language], 'policyOwner'))
                setPolicyNumberText(languageMessages(languageMap[session.language], 'policyNumber'))
                setPlan(languageMessages(languageMap[session.language], 'plan'))
                setTerm(languageMessages(languageMap[session.language], 'term'))
                setPremium(languageMessages(languageMap[session.language], 'premium'))
                setInformationPayment(new Map(Object.entries(
                    {
                        [A1]: session?.first_name + ' ' + session?.last_name,
                        //[A2]: session?.first_name + ' ' + session?.last_name,
                        [A3]: session?.id_application || '',
                    }
                )));
                const nextPayment = session?.payments?.[0];
                setInformationUpdate(new Map(Object.entries(
                    {
                        [A1]: session?.first_name + ' ' + session?.last_name || '',
                        [A3]: session?.id_application || '',
                        [A5]: session?.term || '',
                        ...(nextPayment && { [A6]: session?.currency + ' $' + getAmountWithTwoDecimalsAndMilles(nextPayment.amount, REACT_APP_COUNTRY_DEPLOY) }),
                    }
                )));
                setIsOpen(false);
            } catch (error) {
                if (!isMounted) return;
                Sentry.captureException(error, { tags: { service: 'linkService[getHashInfo]' }, extra: { session: sessionToken } });
                setError({
                    title: languageMessages(language, 'errorMessages')['session'].title,
                    subtitle: languageMessages(language, 'errorMessages')['session'].subtitle,
                    buttonText: languageMessages(language, 'errorMessages')['session'].buttonText
                });
                setIsOpen(true);
                //console.error('Error getting session:', error);
            } finally {
                if (isMounted) setSessionLoaded(true);
                setSessionLoaded(true);
            }
        };
        fetchData();
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line
    //}, [sessionData, objectData, location.search, sessionLoaded, language, changeLanguage, INSURED_TEXT, POLICY_OWNER_TEXT, POLICY_NUMBER_TEXT]);
// eslint-disable-next-line
}, [location.search]);

    useEffect(() => {
        if (success === false || retry === -1) return;
        const fetchData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const sessionToken = queryParams.get('subscription') ?? '';
            const session: any = await getHashInfo(sessionToken, region);
            if (!canOpenLink(selectedLinkOption === 'update' ? 'update' : 'payment', session.payments)) {
                setError({
                    title: languageMessages(language, 'errorMessages')['notPendingPayments'].title,
                    subtitle: languageMessages(language, 'errorMessages')['notPendingPayments'].subtitle,
                    buttonText: languageMessages(language, 'errorMessages')['notPendingPayments'].buttonText
                });
                setIsOpen(true);
                console.warn('session', languageMessages(language, 'errorMessages')['notPendingPayments'].subtitle);
                return;
            }
            setSessionData(session);
            setObjectData(transformLinkResponse(session));
        }
        fetchData();
    // eslint-disable-next-line
    }, [success]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const option = queryParams.get('option') ?? '';
        if (option === 'update') {
            setSelectedLinkOption('update');
            localStorage.setItem('selectedLinkOption', 'update');
        }
        console.log('option link payment V3 :::', option);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        if (!queryParams.has('option')) {
            return;
        }
        const option = queryParams.get('option') ?? '';
        setSelectedLinkOption('payment');
        localStorage.setItem('selectedLinkOption', 'payment');
        if (option === 'update') {
            setSelectedLinkOption('update');
            localStorage.setItem('selectedLinkOption', 'update');
        }
        console.log('option link payment V3 :::', option);
    }, [location.search]);

    const handleCheckboxChange = (id: number) => {
        const updatedDues = objectData?.dues.map((due:any, index:number) => {
            if (index > 0 && due.id === id) {
                due.checked = !due.checked;
                if (index < objectData.dues.length - 1) {
                    objectData.dues[index + 1].disabled = !due.checked;
                    objectData.dues[index + 1].checked = false;
                    for (let i = index + 2; i < objectData.dues.length; i++) {
                        objectData.dues[i].checked = false;
                        objectData.dues[i].disabled = true;
                    }
                }
            }
            return due;
        });
        const roundedTotal = sumCheckedDues(updatedDues ?? []);
        const ids = objectData.dues.filter((due: any) => due.checked).map((due: any) => { return due.id; });
        const newData: Partial<TransformedData> = { dues: updatedDues ?? [], amount: roundedTotal, paymentIds: ids };
        setObjectData((prevData: any) => ({ ...prevData, ...newData }));
    };

    const changeOption = (newOption: React.SetStateAction<string>) => {
        const option = newOption.toString() === 'update' ? 'update' : 'payment';
        localStorage.setItem('selectedLinkOption', option);
        window.location.assign(linkUrlWithOption(location.pathname, location.search, option));
    };

    const goPassarel = async (region: string) => {
        if (selectedLinkOption === 'payment') {
            if (checkingPendingRef.current) return; // evita doble-clic mientras corre la validación
            checkingPendingRef.current = true;
            const idPayment = objectData?.paymentIds?.[0];
            let pending = true;
            try {
                pending = await isPaymentPending(idPayment);
            } finally {
                checkingPendingRef.current = false;
            }
            if (!pending) {
                setError({
                    title: languageMessages(language, 'errorMessages')['notPendingPayments'].title,
                    subtitle: languageMessages(language, 'errorMessages')['notPendingPayments'].subtitle,
                    buttonText: languageMessages(language, 'errorMessages')['notPendingPayments'].buttonText
                });
                setIsOpen(true);
                return; // no abre Flywire
            }
        }
        const provider = getProvider(region, objectData?.gateway);
        if (provider === 'authnet') {
            const ids = objectData?.dues
                ? objectData.dues.filter((due: any) => due.checked).map((due: any) => due.id)
                : objectData?.paymentIds ?? [];
            startAuthorizeNetLink({
                intent: selectedLinkOption === 'payment' ? 'checkout' : 'updateCard',
                ids,
                payer: buildLinkPayer(objectData),
            });
            return;
        }
        callFormPayment();
    }

    const callFormPayment = () => {
        let _object = objectData;
        setObjectData(_object);
        setRetry(retry + 1);
    };

    const handleClose = () => {
        setIsOpen(false);
    };
    
    const handleButtonClick = () => {
        window.location.reload();
    };

    const hasAdvancePayment = () => {
        const dues = objectData?.dues ?? [];
        // Una cuota es adelantada si su fecha es mayor a 1 día respecto a la fecha actual.
        const limit = new Date();
        limit.setHours(0, 0, 0, 0);
        limit.setDate(limit.getDate() + 1); // hoy + 1 día
        return dues.some((due: any) => {
            if (!due.checked || !due.paymentDate || due.paymentDate.length < 10) return false;
            const year = parseInt(due.paymentDate.substring(0, 4), 10);
            const month = parseInt(due.paymentDate.substring(5, 7), 10) - 1;
            const day = parseInt(due.paymentDate.substring(8, 10), 10);
            const dueDate = new Date(year, month, day);
            return dueDate.getTime() > limit.getTime();
        });
    };

    const handleButtonContinue = () => {
        if (hasAdvancePayment()) {
            setIsOpenEarlyPayment(true);
            return;
        }
        setStepActive(false);
    }

    const handleButtonReturn = () => {
        if (isVantage) {
            try {
                //@ts-ignore
                window.ReactNativeWebView.postMessage("session-back");
            } catch (error) {
                console.error('session-back', error);
            }
            return;
        }
    }

    const handleBackStep = () => {
        setStepActive(true);
    }

    const showInformation = () => {
        setIsOpenInformation(true);
    }

    const onInactive = () => {
        console.warn('activity', 'User inactive');
        window.location.href = '/';
    }

    return (
        <Layout inactivityTime={Number.parseInt(REACT_APP_TIME_REFRESH)} onInactive={onInactive}>
        <LinkOptionContext.Provider value={{ option: selectedLinkOption, changeOption, canPay }}>
            {isOpen && (
            <Dialog
                title={error===null ? '' : error.title}
                subtitle={error===null ? '' : error.subtitle}
                buttonText={error===null ? '' : error.buttonText}
                onClose={handleClose}
                onButtonClick={handleButtonClick}
                showClose={false}
                />
            )}
            {isOpenInformation && (
            <OlePopupInformation
                information={selectedLinkOption === 'payment' ? informationPayment : informationUpdate}
                title={languageMessages(language, 'policyInformation')}
                onClose={() => setIsOpenInformation(false)}
            />
            )}
            {isOpenEarlyPayment && (
            <EarlyPaymentPopup
                title={languageMessages(language, 'earlyPaymentTitle')}
                message={languageMessages(language, 'earlyPaymentMessage')}
                confirmText={languageMessages(language, 'earlyPaymentConfirm')}
                cancelText={languageMessages(language, 'earlyPaymentCancel')}
                onConfirm={() => { setIsOpenEarlyPayment(false); setStepActive(false); }}
                onClose={() => setIsOpenEarlyPayment(false)}
            />
            )}
            {sessionLoaded ? (
            <div className='app'>
                <Header 
                    paymentType='link' 
                    language={language} 
                    showLogo={true} 
                />
                <div className='payment-header-link' style={selectedLinkOption === 'payment' && !success ? {display : 'block'} : {display: 'none'}}>
                    <div className=''>
                        <div className='return' style={isVantage ? {display: 'block'}: {display: 'none'}}>
                            <div><img src='../link-return.svg' alt='return' onClick={handleButtonReturn} /></div>
                        </div>
                        <div className='step'>
                            <div className='step-1' style={ stepActive ? {display: 'block'} : {display: 'none'}}>
                                <img src='../link-step-1.svg' alt='step1' />
                            </div>
                            <div className='step-2' style={ !stepActive ? {display: 'block'} : {display: 'none'}}>
                                <img src='../link-step-2.svg' alt='step2' onClick={handleBackStep} />
                            </div>
                        </div>
                    </div>
                    <span className='title' style={ stepActive ? {display: 'block'} : {display: 'none'}}>{languageMessages(language, 'titleStep1')}</span>
                    <span className='title' style={ !stepActive ? {display: 'block'} : {display: 'none'}}>{languageMessages(language, 'titleStep2')}</span>
                    <div className='paymentInfo' style={ !stepActive ? {display: 'block'} : {display: 'none'}}>
                        <div className='description'>{languageMessages(language, "totalPayment")}</div>
                        <div className='amount'> {objectData?.currency} {objectData?.symbol}{getAmountWithTwoDecimalsAndMilles(objectData?.amount, REACT_APP_COUNTRY_DEPLOY)}<span></span></div>
                    </div>
                </div>
                <div className = { selectedLinkOption === 'payment' ? 'information-t1' : 'information-t2' } style={success ? {display: 'none'} : {}}>
                    <div style={!stepActive ? {display: 'none'} : {display: 'block'}}>
                        <img src='../link-info.svg' alt='information' />
                    </div>
                    <div  style={!stepActive ? {display: 'none'} : {display: 'block'}} className='click' onClick={showInformation}>&nbsp;&nbsp;{languageMessages(language, 'policyInformation')}</div>
                </div>
                <div className='payment-body-link' style={!success ? { display: 'flex' } : { display: 'none' }}>
                    <div className={selectedLinkOption === 'payment' ? 'payment-body-table' : 'payment-body-table-update'} style={ stepActive ? {display: 'block'} : {display: 'none'}}>
                        <div className='payment-data-link'>
                            <div className='title' style = {selectedLinkOption === 'payment' ? { display: 'none' } : { display: 'block' }}>
                                <span style={{ fontWeight: 'bold' }}><strong>{languageMessages(language, 'policyInformation')}</strong></span>
                            </div>
                            <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                <span style={{ fontWeight: 'bold' }}>{languageMessages(language, 'insured')}</span> {objectData?.insured}
                            </div>
                            <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                <span style={{ fontWeight: 'bold' }}>{languageMessages(language, 'policyNumber')}</span> {objectData?.policyNumber}
                            </div>
                            <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                <span style={{ fontWeight: 'bold' }}>{languageMessages(language, 'term')}</span> {objectData?.term}
                            </div>
                            <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                <span style={{ fontWeight: 'bold' }}>{languageMessages(language, 'period')[objectData?.paymentFrequency]}</span> {objectData?.premium}
                            </div>
                        </div>
                    </div>
                    <div className='payment-form-link' style={ stepActive ? {display: 'flex'} : {display: 'none'}}>                        
                        <div className='payment-quotes-link' style={selectedLinkOption === 'update' ? { display: 'none' } : { display: 'block' }}>
                            <div className='payment-data-link'>
                                <div className='title' style = {selectedLinkOption === 'payment' ? { display: 'none' } : { display: 'block' }}>
                                    <span style={{ fontWeight: 'bold' }}><strong>{languageMessages(language, 'policyInformation')}</strong></span>
                                </div>
                                <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                    <span style={{ fontWeight: 'bold' }}>{languageMessages(language, 'insured')} </span> {objectData?.insured}
                                </div>
                                <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                    <span style={{ fontWeight: 'bold' }}>{languageMessages(language, 'policyNumber')} </span> {objectData?.policyNumber}
                                </div>
                                <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                    <span style={{ fontWeight: 'bold' }}>{languageMessages(language, 'term')} </span> {objectData?.term}
                                </div>
                                <div className='row' style={selectedLinkOption === 'payment' ? { paddingTop: '10px', paddingBottom: '10px' } : { paddingTop: '15px', paddingBottom: '15px' }}>
                                    <span style={{ fontWeight: 'bold' }}>{ languageMessages(language, 'period')[objectData?.paymentFrequency] }:</span> {objectData?.premium}
                                </div>
                            </div>
                            <div className='table'>
                                <table cellSpacing={0}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>{languageMessages(language, 'tableTitle2')}</th>
                                            <th>{languageMessages(language, 'tableTitle3')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {objectData?.dues && (
                                            objectData?.dues.map((row:any) => (
                                                <tr key={row.id}>
                                                    <td>
                                                        <OleCheckbox id={row.id} checked={row.checked} onChange={handleCheckboxChange} disabled={row.disabled} text='' />
                                                    </td>
                                                    <td>{row.dueDate}</td>
                                                    <td style={row.withDelay ? { color: '#D00', fontWeight: 'bold' } : { color: '#00D090', fontWeight: 'bold' }}>{row.currency} {row.symbol}{row.premium}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className='confirmation_continue'>
                                <span className='title'>{languageMessages(language, 'totalPayment')}</span>
                                <span className='amount'>{(objectData?.currency + ' ' + objectData?.symbol + getAmountWithTwoDecimalsAndMilles(objectData?.amount, REACT_APP_COUNTRY_DEPLOY)).replaceAll('undefined', '')}</span>
                                <div className='button' onClick={handleButtonContinue}>{languageMessages(language, 'continueButton')}</div>
                            </div>
                        </div>
                        <div style={selectedLinkOption === 'update' ? { display: 'block' } : { display: 'none' }}>
                            {objectData && <FormPersonalData objectData={objectData} onClick={() => goPassarel(region)} language={language} buttonText={selectedLinkOption === 'payment' ? languageMessages(language, "payNowAprroved") : languageMessages(language, "updateCard")} showRecurrent = {false} />}
                            <div className='authorize'>
                                <div className='message'>{languageMessages(language, "authorizeMessage")}</div>
                            </div>
                        </div>
                    </div>
                    <div className='data' style={ !stepActive ? {display: 'block'} : {display: 'none'}}>
                        {objectData && <FormPersonalData objectData={objectData} onClick={() => goPassarel(region)} language={language} buttonText={selectedLinkOption === 'payment' ? languageMessages(language, "payNowAprroved") : languageMessages(language, "updateCard")} showRecurrent />}
                    </div>
                </div>
                <div style={success ? { display: 'block' } : { display: 'none' }}>
                    <PageConfirmation 
                        language = {language} 
                        firstname = {objectData?.firstName} 
                        amount = {objectData?.currency + ' ' + objectData?.symbol + getAmountWithTwoDecimalsAndMilles(resolveConfirmationAmount(amountPayment, objectData), REACT_APP_COUNTRY_DEPLOY)} 
                        policy = {objectData?.policyNumber} 
                        type = {selectedLinkOption} 
                        card = {result?.digits} 
                        date = {objectData?.dues?.[0]?.dueDate ?? ''}
                        outcome = {resolvePaymentOutcome(getProvider(region, objectData?.gateway), status)}
                        awaitsBankTransfer = {expectsBankTransfer(status, paymentMethod)}
                        onRetry = {() => { setSuccess(false); goPassarel(region); }}
                    />
                </div>
            </div>
            ) : (
                <Skeleton />
            )}
            {authnetLoaded && !authnetFormToken && <Skeleton />}
            {getProvider(region, objectData?.gateway) === 'authnet' ? (
                <FormAuthorizeNet
                    formToken={authnetFormToken}
                    onClose={closeAuthorizeNetLink}
                />
            ) : (
                <FormFlyware
                    objectData={objectData}
                    region={region}
                    isModal={true}
                    retry={retry}
                    session={token}
                    onCompleteFlywire={responseflywire}
                />
            )}
            {/*
              openPopupStripe && <Popup
                width={643}
                paddingBottom={60}
                onClose={() => setOpenPopupStripe(false)}>
                    <StripeWrapper>
                        <FormStripe
                            session={token}
                            region={region}
                            email={objectData?.email}
                            name={objectData?.firstName + ' ' + objectData?.lastName}
                            onlyTokenize={localStorage.getItem('selectedLinkOption') === 'update'}
                            onCompleteStripe={(dato:any, provider:string) => responseStripe(dato, provider)}
                            isModal={true}
                            url='link'
                            currency= {objectData?.currency}
                            amount={objectData?.amount || objectData?.amountStart}
                            idQuotation={objectData?.idQuotation}
                            idApplication={objectData?.idApplication || ''}
                            payingForPolicy={objectData?.payingForPolicy || ''}
                            payment_installments={objectData?.paymentIds?.join(',') || ''}
                        />
                    </StripeWrapper>
                </Popup>
            */}
        </LinkOptionContext.Provider>
        </Layout>
    );
}

export default PaymentLink;